import React from 'react';
import { IconProps } from '../types';
const MinecraftWheatSeeds: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="4" width="1" height="1" fill="rgba(0, 226, 16, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(0, 226, 16, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(105, 176, 56, 255)" />
<rect x="12" y="5" width="1" height="1" fill="rgba(0, 226, 16, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(46, 67, 12, 255)" />
<rect x="12" y="6" width="1" height="1" fill="rgba(105, 176, 56, 255)" />
<rect x="13" y="6" width="1" height="1" fill="rgba(105, 176, 56, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(0, 226, 16, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(105, 176, 56, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(68, 114, 36, 255)" />
<rect x="12" y="7" width="1" height="1" fill="rgba(46, 67, 12, 255)" />
<rect x="13" y="7" width="1" height="1" fill="rgba(46, 67, 12, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(0, 226, 16, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(172, 176, 56, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(46, 67, 12, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(46, 67, 12, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(105, 176, 56, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(68, 114, 36, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(46, 67, 12, 255)" />
<rect x="3" y="10" width="1" height="1" fill="rgba(46, 67, 12, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(46, 67, 12, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(0, 226, 16, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(172, 176, 56, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(111, 114, 36, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(105, 176, 56, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(68, 114, 36, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(46, 67, 12, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(46, 67, 12, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(46, 67, 12, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(46, 67, 12, 255)" />
</svg>);
export default MinecraftWheatSeeds;